export class DrawViewController {

    constructor($log, $window, $state, UserSessionService) {
        'ngInject';

        this.$log = $log;
        this.$window = $window;
        this.$state = $state;
        this.userSessionService = UserSessionService;

        this.$log.debug('DrawViewController:constructor');

    }

    $onInit() {
        this.$log.debug('DrawViewController:$onInit');
    }

    $onDestroy() {
        this.$log.debug('DrawViewController::$onDestroy');
    }

    nextStep() {
        if (!this.userSessionService.getDoors().length) {
            this.$window.alert('You need to add one or more doors before you can proceed.');
        } else {
            this.$state.go('design');
        }
    }

}



// WEBPACK FOOTER //
// ./src/js/views/draw-view/draw-view.controller.js